import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "notice bg-light-warning rounded border-warning border border-dashed p-4 mb-4"
}
const _hoisted_2 = { class: "d-flex align-items-center mb-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle-fill text-warning fs-4 me-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 fs-7" }, "Thông tin lệch giữa Nhập học / Ứng viên / Trúng tuyển", -1)
const _hoisted_5 = { class: "badge badge-warning ms-2" }
const _hoisted_6 = { class: "fs-8 text-gray-700 mb-2 ms-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("b", null, "không thống nhất", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "chọn bản đúng ở cuối khung", -1)
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table table-row-dashed align-middle fs-8 mb-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-1" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-1" }, "Nhập học"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-1" }, "Ứng viên"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-1" }, "Trúng tuyển")
  ])
], -1)
const _hoisted_12 = { class: "p-1 fw-bolder text-gray-800 text-nowrap" }
const _hoisted_13 = { class: "p-1 fw-bolder text-gray-900" }
const _hoisted_14 = { class: "p-1" }
const _hoisted_15 = { class: "p-1" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "fs-8 text-gray-600 mb-3" }, " Ô trống trên bảng nguồn sẽ được bỏ qua — đồng bộ không xóa dữ liệu đang có ở bảng khác. ", -1)
const _hoisted_17 = {
  key: 0,
  class: "pt-3 mt-2 border-top border-warning border-opacity-50"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "fs-8 text-gray-700 mb-2 text-center" }, [
  /*#__PURE__*/_createTextVNode("Dữ liệu ở bảng nào là "),
  /*#__PURE__*/_createElementVNode("b", null, "bản đúng"),
  /*#__PURE__*/_createTextVNode("? Chọn bên dưới — hệ sẽ ghi đè 2 bảng còn lại:")
], -1)
const _hoisted_19 = { class: "d-flex justify-content-center flex-wrap gap-3" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-vcard fs-2 me-3" }, null, -1)
const _hoisted_22 = { class: "d-flex flex-column align-items-start" }
const _hoisted_23 = { class: "fw-bolder" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "fs-9 fw-normal" }, "Ứng viên → ghi đè Nhập học + Trúng tuyển", -1)
const _hoisted_25 = ["disabled"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-mortarboard fs-2 me-3" }, null, -1)
const _hoisted_27 = { class: "d-flex flex-column align-items-start" }
const _hoisted_28 = { class: "fw-bolder" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "fs-9 fw-normal" }, "Nhập học → ghi đè Ứng viên + Trúng tuyển", -1)
const _hoisted_30 = {
  key: 1,
  class: "text-muted fs-8 text-end"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-lock-fill me-1" }, null, -1)
const _hoisted_32 = {
  key: 1,
  class: "text-muted fs-8 mb-4"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle-fill text-success me-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.syncDiffs.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.syncDiffs.length) + " trường lệch — cần xử lý", 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode(" Để nguyên thì phiếu nhập học, quyết định trúng tuyển và dữ liệu đẩy SIS sẽ "),
          _hoisted_7,
          _createTextVNode(". "),
          (_ctx.canSync)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("Rà bảng dưới rồi "),
                _hoisted_8,
                _createTextVNode(" để đồng bộ một lần.")
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("table", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.syncDiffs, (d) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: d.key
                }, [
                  _createElementVNode("td", _hoisted_12, _toDisplayString(d.label), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(d.applicant), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(d.student === null ? '·' : d.student), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(d.winner === null ? '·' : d.winner), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _hoisted_16,
        (_ctx.canSync)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                (!_ctx.studentAllEmpty)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-light-primary d-flex align-items-center px-4 py-2 text-start",
                      disabled: _ctx.syncing,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.syncIdentity('student'))),
                      title: "Dùng khi vừa sửa đúng ở trang chi tiết ứng viên"
                    }, [
                      _hoisted_21,
                      _createElementVNode("span", _hoisted_22, [
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.syncing ? 'Đang đồng bộ…' : 'Ứng viên là bản đúng'), 1),
                        _hoisted_24
                      ])
                    ], 8, _hoisted_20))
                  : _createCommentVNode("", true),
                (!_ctx.applicantAllEmpty)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn btn-light-warning d-flex align-items-center px-4 py-2 text-start",
                      disabled: _ctx.syncing,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.syncIdentity('applicant'))),
                      title: "Dùng khi thí sinh vừa cập nhật đúng trên cổng nhập học"
                    }, [
                      _hoisted_26,
                      _createElementVNode("span", _hoisted_27, [
                        _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.syncing ? 'Đang đồng bộ…' : 'Nhập học là bản đúng'), 1),
                        _hoisted_29
                      ])
                    ], 8, _hoisted_25))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _hoisted_31,
              _createTextVNode("Phiếu đã khóa — chỉ xem thông tin lệch, không đồng bộ")
            ]))
      ]))
    : (_ctx.syncChecked && _ctx.showMatchNote)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _hoisted_33,
          _createTextVNode("Thông tin khớp giữa hồ sơ Ứng viên / Trúng tuyển / Nhập học ")
        ]))
      : _createCommentVNode("", true)
}